"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data = [
    {
        name: 'NZ (+64)',
        value: '0064'
    },
    {
        name: 'AU (+61)',
        value: '0061'
    },
    {
        name: 'UK (+44)',
        value: '0044'
    },
    {
        name: 'US (+1)',
        value: '001'
    }
];
exports.default = data;
//# sourceMappingURL=data.js.map